import {html} from 'lit-html';

import TemplateRegistry from '../template/template-registry';

// formula value always hidden (hacky way to hide the label as well - could be refactored with a new option.params.hidden setting)
TemplateRegistry.templates['value-formula'] = (option, config, onChange) => html`
        <style>[data-option="${option.name}"] { display:none; }</style>
        ${TemplateRegistry.templates['hidden'](option, config, onChange)}}
`;